import { render } from "./CardRowComponent.vue?vue&type=template&id=96e94dba&ts=true"
import script from "./CardRowComponent.vue?vue&type=script&lang=ts"
export * from "./CardRowComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__